import React, {FC, useMemo} from "react";
import {NotificationSimple} from "./NotificationSimple";
import {NotificationLike} from "./NotificationLike";
import {NotificationBottomDate} from "./NotificationBottomDate";
import {NotificationLMSAdd} from "./NotificationLMSAdd";
import {NotificationLMSComment} from "./NotificationLMSComment";
import {NotificationLMSApprove} from "./NotificationLMSApprove";
import { NotificationSendFile } from "./NotificationSendFile";
import {NotificationCoauthorAdd} from "./NotificationCoauthorAdd";
import {NotificationCoauthorRemove} from "./NotificationCoauthorRemove";
import {INotificationComponent, NotificationTypes} from "../const/const";
import {NotificationLMSExamResult} from "./NotificationLMSExamResult";
import {NotificationBook} from "./NotificationBook";
import { NotificationAutoTranlationComplete } from "./NotificationAutoTranlationComplete";
import { NotificationNewPromoCode } from "./NotificationNewPromoCode";
import { NotificationCompetitionApplyResult } from "./NotificationCompetitionApplyResult";
import { NotificationLMSLessonScheduled } from "./NotificationLMSLessonScheduled";
import { NotificationLMSExamScheduled } from "./NotificationLMSExamScheduled";
import { NotificationCertificate } from "./NotificationCertificate";
import { NotificationChannel } from "./NotificationChannel";
import { NotificationChannelLike } from "./NotificationChannelLike";
import { NotificationChannelMemberAdd } from "./NotificationChannelMemberAdd";
import { NotificationChannelMemberRemove } from "./NotificationChannelMemberRemove";
import { NotificationChannelArchive } from "./NotificationChannelArchive";
import { NotificationProjectBanned } from "./NotificationProjectBanned";

export const NotificationComponentController: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const NotificationComponentList: Record<NotificationTypes, INotificationComponent> = useMemo(() => ({
        [NotificationTypes.LIKE]: {
            component: <NotificationLike item={item}/>
        },
        [NotificationTypes.BOOK]: {
            component: <NotificationBook item={item}/>
        },
        [NotificationTypes.SIMPLE]: {
            component: <NotificationSimple item={item}/>
        },
        [NotificationTypes.LMS_HOMEWORK_COMMENT]: {
            component: <NotificationLMSComment item={item}/>
        },
        [NotificationTypes.LMS_HOMEWORK_APPROVE]: {
            component: <NotificationLMSApprove item={item}/>
        },
        [NotificationTypes.LMS_HOMEWORK_ADD]: {
            component: <NotificationLMSAdd item={item}/>
        },
        [NotificationTypes.SEND_FILE]: {
            component: <NotificationSendFile item={item}/>
        },
        [NotificationTypes.COAUTHOR_ADD]: {
            component: <NotificationCoauthorAdd item={item}/>
        },
        [NotificationTypes.COAUTHOR_REMOVE]: {
            component: <NotificationCoauthorRemove item={item}/>
        },
        [NotificationTypes.EXAM_RESULT]: {
            component: <NotificationLMSExamResult item={item}/>
        },
        [NotificationTypes.AUTO_TRANSLATION_COMPLETE_PRJ]: {
            component: <NotificationAutoTranlationComplete item={item}/>
        },
        [NotificationTypes.NEW_PROMO_CODE_RECIEVED]: {
            component: <NotificationNewPromoCode item={item}/>
        },
        [NotificationTypes.COMPETITION_APPLY_RESULT_RECIEVED]: {
            component: <NotificationCompetitionApplyResult item={item}/>
        },
        [NotificationTypes.LMS_LESSON_SCHEDULED]: {
            component: <NotificationLMSLessonScheduled item={item}/>
        },
        [NotificationTypes.LMS_EXAM_SCHEDULED]: {
            component: <NotificationLMSExamScheduled item={item}/>
        },
        [NotificationTypes.CERTIFICATION_OPERATION]: {
            component: <NotificationCertificate item={item}/>
        },
        [NotificationTypes.channel_comment]: {
            component: <NotificationChannel item={item}/>
        },
        [NotificationTypes.channel_like]: {
            component: <NotificationChannelLike item={item}/>
        },
        [NotificationTypes.channel_member_add]: {
            component: <NotificationChannelMemberAdd item={item}/>
        },
        [NotificationTypes.channel_member_remove]: {
            component: <NotificationChannelMemberRemove item={item}/>
        },
        [NotificationTypes.channel_archive]: {
            component: <NotificationChannelArchive item={item}/>
        },
        [NotificationTypes.PROJECT_BANNED]: {
            component: <NotificationProjectBanned item={item}/>
        },
    }), [item])

    const notificationType: NotificationTypes = useMemo(() => (actions?.length > 0 ? (actions[0]?.type || '') : '') ,[actions])
    const activeComponent = useMemo(() => typeof NotificationComponentList[notificationType] !== "undefined" ? NotificationComponentList[notificationType] : undefined,[NotificationComponentList, notificationType])

    if (activeComponent === undefined || activeComponent?.component === null) return null;

    return <>
        {activeComponent?.component}
        {!activeComponent?.withoutDate && <NotificationBottomDate item={item}/>}
    </>;
}import React, {FC, useMemo} from "react";
import {NotificationSimple} from "./NotificationSimple";
import {NotificationLike} from "./NotificationLike";
import {NotificationBottomDate} from "./NotificationBottomDate";
import {NotificationLMSAdd} from "./NotificationLMSAdd";
import {NotificationLMSComment} from "./NotificationLMSComment";
import {NotificationLMSApprove} from "./NotificationLMSApprove";
import { NotificationSendFile } from "./NotificationSendFile";
import {NotificationCoauthorAdd} from "./NotificationCoauthorAdd";
import {NotificationCoauthorRemove} from "./NotificationCoauthorRemove";
import {INotificationComponent, NotificationTypes} from "../const/const";
import {NotificationLMSExamResult} from "./NotificationLMSExamResult";
import {NotificationBook} from "./NotificationBook";
import { NotificationAutoTranlationComplete } from "./NotificationAutoTranlationComplete";
import { NotificationNewPromoCode } from "./NotificationNewPromoCode";
import { NotificationCompetitionApplyResult } from "./NotificationCompetitionApplyResult";
import { NotificationLMSLessonScheduled } from "./NotificationLMSLessonScheduled";
import { NotificationLMSExamScheduled } from "./NotificationLMSExamScheduled";
import { NotificationCertificate } from "./NotificationCertificate";
import { NotificationChannel } from "./NotificationChannel";
import { NotificationChannelLike } from "./NotificationChannelLike";
import { NotificationChannelMemberAdd } from "./NotificationChannelMemberAdd";
import { NotificationChannelMemberRemove } from "./NotificationChannelMemberRemove";
import { NotificationChannelArchive } from "./NotificationChannelArchive";
import { NotificationProjectBanned } from "./NotificationProjectBanned";

export const NotificationComponentController: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const NotificationComponentList: Record<NotificationTypes, INotificationComponent> = useMemo(() => ({
        [NotificationTypes.LIKE]: {
            component: <NotificationLike item={item}/>
        },
        [NotificationTypes.BOOK]: {
            component: <NotificationBook item={item}/>
        },
        [NotificationTypes.SIMPLE]: {
            component: <NotificationSimple item={item}/>
        },
        [NotificationTypes.LMS_HOMEWORK_COMMENT]: {
            component: <NotificationLMSComment item={item}/>
        },
        [NotificationTypes.LMS_HOMEWORK_APPROVE]: {
            component: <NotificationLMSApprove item={item}/>
        },
        [NotificationTypes.LMS_HOMEWORK_ADD]: {
            component: <NotificationLMSAdd item={item}/>
        },
        [NotificationTypes.SEND_FILE]: {
            component: <NotificationSendFile item={item}/>
        },
        [NotificationTypes.COAUTHOR_ADD]: {
            component: <NotificationCoauthorAdd item={item}/>
        },
        [NotificationTypes.COAUTHOR_REMOVE]: {
            component: <NotificationCoauthorRemove item={item}/>
        },
        [NotificationTypes.EXAM_RESULT]: {
            component: <NotificationLMSExamResult item={item}/>
        },
        [NotificationTypes.AUTO_TRANSLATION_COMPLETE_PRJ]: {
            component: <NotificationAutoTranlationComplete item={item}/>
        },
        [NotificationTypes.NEW_PROMO_CODE_RECIEVED]: {
            component: <NotificationNewPromoCode item={item}/>
        },
        [NotificationTypes.COMPETITION_APPLY_RESULT_RECIEVED]: {
            component: <NotificationCompetitionApplyResult item={item}/>
        },
        [NotificationTypes.LMS_LESSON_SCHEDULED]: {
            component: <NotificationLMSLessonScheduled item={item}/>
        },
        [NotificationTypes.LMS_EXAM_SCHEDULED]: {
            component: <NotificationLMSExamScheduled item={item}/>
        },
        [NotificationTypes.CERTIFICATION_OPERATION]: {
            component: <NotificationCertificate item={item}/>
        },
        [NotificationTypes.channel_comment]: {
            component: <NotificationChannel item={item}/>
        },
        [NotificationTypes.channel_like]: {
            component: <NotificationChannelLike item={item}/>
        },
        [NotificationTypes.channel_member_add]: {
            component: <NotificationChannelMemberAdd item={item}/>
        },
        [NotificationTypes.channel_member_remove]: {
            component: <NotificationChannelMemberRemove item={item}/>
        },
        [NotificationTypes.channel_archive]: {
            component: <NotificationChannelArchive item={item}/>
        },
        [NotificationTypes.PROJECT_BANNED]: {
            component: <NotificationProjectBanned item={item}/>
        },
    }), [item])

    const notificationType: NotificationTypes = useMemo(() => (actions?.length > 0 ? (actions[0]?.type || '') : '') ,[actions])
    const activeComponent = useMemo(() => typeof NotificationComponentList[notificationType] !== "undefined" ? NotificationComponentList[notificationType] : undefined,[NotificationComponentList, notificationType])

    if (activeComponent === undefined || activeComponent?.component === null) return null;

    return <>
        {activeComponent?.component}
        {!activeComponent?.withoutDate && <NotificationBottomDate item={item}/>}
    </>;
}